// item 28: глобальный lock скролла (против «резинки» страницы) НЕ должен блокировать
// нативный скролл ВНУТРИ прокручиваемых контейнеров — иначе на iOS (Chrome/Safari)
// список стран в магазине (и любой другой overflow-контейнер в модалке) не листался.
// Пропускаем touchmove, если палец внутри реально прокручиваемого элемента.
function lockRubberBand(e) {
  let el = e.target;
  for (let i = 0; el && el !== document.body && i < 12; i++) {
    if (el.dataset && el.dataset.allowScroll !== undefined) return;
    const oy = window.getComputedStyle(el).overflowY;
    if (
      (oy === "auto" || oy === "scroll") &&
      el.scrollHeight > el.clientHeight + 1
    ) {
      return; // внутри настоящего скролл-контейнера — не мешаем
    }
    el = el.parentElement;
  }
  e.preventDefault();
}

export function disableRubberBandScroll() {
  document.addEventListener("touchmove", lockRubberBand, { passive: false });
}

export function enableRubberBandScroll() {
  document.removeEventListener("touchmove", lockRubberBand);
}
